























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { accountHistory } from '@/api/order';
import utils from '@/utils/utils';
import AMSImg from '@/components/AMSImg.vue';
import moment from 'moment';
import AMSTable from '@/components/AMSTable.vue';
import AMSProductImg from '@/components/AMSProductImg.vue';
@Component({
  components: {
    'ams-img': AMSImg,
    'ams-table': AMSTable
  }
})
export default class ShipCharge extends Vue {
  /**订单信息 */
  @Prop({
    default: () => {
      return {};
    }
  })
  orderInfo!: any;
  @Prop({
    default: () => {
      return {};
    }
  })
  charge!: any;
  showIcon: string = 'unfold_less';
  hideIcon: string = 'unfold_more';
  // 配货headers
  headers: object = {
    chargeHeaders: [
      { text: '序号', isSort: true, align: 'center', sortable: false, width: '50px' },
      {
        text: '商品',
        value: 'product',
        render: (h: any, param: any) => {
          return h(AMSProductImg, {
            props: {
              product: param.row[param.keyName],
              pictureWidth: 40,
              pictureHeight: 40,
              isShowNumber: true
            }
          });
        },
        align: 'left',
        sortable: false,
        width: '300px'
      },
      {
        text: '容量',
        align: 'right',
        sortable: false,
        value: 'capacity',
        render: (h: any, param: any) => {
          return h('div', param.row.product.capacity);
        }
      },
      { text: '订购量', align: 'right', sortable: false, value: 'quantity' },
      { text: '出货量', align: 'right', sortable: false, value: 'stockQuantity' },
      { text: '单价', align: 'right', sortable: false, value: 'price' },
      { text: '扣款金额', align: 'right', sortable: false, value: 'amount' }
    ]
  };

  formatDateTime(date: any) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }
  getTotalCount(item: any) {
    let count = 0;
    item.map((v: any) => {
      if (!isNaN(parseInt(v.stockQuantity))) {
        count += parseInt(v.stockQuantity);
      }
    });
    return count;
  }
}
